import React from 'react'
import { Container, Tabs, Tab } from 'react-bootstrap';
import { data } from '../data';
import {Link} from 'react-router-dom';
const Webinars = () => {
    return (<>
        <Container className="outerContainer">
            <h1 className="centerText mb-4">Webinars</h1>
            <Tabs defaultActiveKey="software-release" className={'qiTabs'}>
                <Tab eventKey="software-release" title="Software Release & Updates">
                    {data.Resources.map((information, a) => (<>
                        <div className="mb-4" key={a}>
                            {information.webinars.map((info, b) => (<>
                                {info.category && info.category.includes('software') ? (<>
                                    <div className="mt-4 mb-5" key={b}>
                                        <h5>{info.date}</h5>
                                        {info.resources.map((details, c) => (
                                            <div key={c}>
                                                <h3>{details.title}</h3>
                                                <ul className="mb-4">
                                                    {details.items.map((item, d) => (
                                                        <div className="mt-4" key={d}>
                                                            <li><a href={item.url}>{item.name} {item.size}</a></li>
                                                        </div>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </>)
                                    : null}
                            </>))}
                        </div>
                    </>))}
                </Tab>
                <Tab eventKey="indicator-changes" title="Indicator Changes">
                    {data.Resources.map((information, a) => (<>
                        <div className="mb-4" key={a}>
                            {information.webinars.map((info, b) => (<>
                                {info.category && info.category.includes('indicator') ? (<>
                                    <div className="mt-4 mb-5" key={b}>
                                        <h5>{info.date}</h5>
                                        {info.resources.map((details, c) => (
                                            <div key={c}>
                                                <h3>{details.title}</h3>
                                                <ul className="mb-4">
                                                    {details.items.map((item, d) => (
                                                        <div className="mt-4" key={d}>
                                                            <li><a href={item.url}>{item.name} {item.size}</a></li>
                                                        </div>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </>)
                                    : null}
                            </>))}
                        </div>
                    </>))}
                </Tab>
                <Tab eventKey="other" title="Other">
                    {data.Resources.map((information, a) => (<>
                        <div className="mb-4" key={a}>
                            {information.webinars.map((info, b) => (<>
                                {info.category && info.category.includes('other') ? (<>
                                    <div className="mt-4 mb-5" key={b}>
                                        <h5>{info.date}</h5>
                                        {info.resources.map((details, c) => (
                                            <div key={c}>
                                                <h3>{details.title}</h3>
                                                <ul className="mb-4">
                                                    {details.items.map((item, d) => (
                                                        <div className="mt-4" key={d}>
                                                            <li><a href={item.url}>{item.name} {item.size}</a></li>
                                                        </div>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </>)
                                    : null}
                            </>))}
                        </div>
                    </>))}
                </Tab>
            </Tabs>
            <p>For webinars prior to 2015 see the <Link to="/archive/resources?1">Archive Resources page</Link>.</p>
                                

        </Container>

    </>
    )
}

export default Webinars;